(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nc-probador-3d"] && !Shopify.designMode) return;
  try {
    
(function () {
  var THREE_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
  function loadThree() {
    if (window.THREE) return Promise.resolve();
    return new Promise(function (res, rej) {
      var s = document.querySelector('script[data-ncp-three]');
      if (!s) { s = document.createElement('script'); s.src = THREE_SRC; s.async = true; s.setAttribute('data-ncp-three', '1'); document.head.appendChild(s); }
      s.addEventListener('load', res); s.addEventListener('error', rej);
      if (window.THREE) res();
    });
  }
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
  var sstep = function (a, b, v) { var t = clamp((v - a) / (b - a), 0, 1); return t * t * (3 - 2 * t); };

  function init(el) {
    if (el.__ncp) return; el.__ncp = true;
    var dataEl = el.querySelector('[data-ncp-data]'), DATA;
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var view = el.querySelector('[data-ncp-view]');
    var T, renderer, scene, camera, root, bodyMats = [], arms, accent = getComputedStyle(el).getPropertyValue('--ncp-accent').trim() || '#2B4EFF';
    var theme = el.getAttribute('data-theme') || 'light';
    var worn = { top: null, bottom: null };          // {G, item, zip}
    var chosen = { top: null, bottom: null };         // item
    var sizeSel = { top: null, bottom: null };        // variant id
    var imgCache = {};
    var scanPlane, scanRing, scanDisc, scanning = 0;
    var theta = 0, omega = 0, alpha = 0, prevOmega = 0, idle = 0, dragRot = false, dragZip = false, lastX = 0, lastT = 0, velX = 0, time = 0, last = performance.now();
    var slider, ZTOP = 1.50, ZBOT = .92, zipY = 1.5, zipT = 1.5;
    var HOOD = { H: .80, top: 1.66 };
    var fmtDeg = el.querySelector('[data-ncp-deg]');
    var floorRings = [], particles;

    function $(s) { return el.querySelector(s); }
    function money(sample, cents) {
      var m = sample && sample.match(/\d[\d.,\s]*\d|\d/);
      if (!m) return (cents / 100).toFixed(2);
      var num = m[0], dec = /[.,]\d{2}$/.test(num), comma = /,\d{2}$/.test(num);
      var v = cents / 100, out = dec ? v.toFixed(2) : String(Math.round(v));
      if (comma) out = out.replace('.', ',');
      return sample.replace(num, out);
    }

    /* ---------- UI ---------- */
    function tile(item, slot) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'ncp__tile'; b.setAttribute('data-slot', slot);
      if (!item) { b.innerHTML = '<span class="ncp__none"><svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M5 5l14 14M19 5 5 19" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linecap="round"/></svg></span><span class="ncp__tname">Sin prenda</span>'; b.setAttribute('data-id', 'none'); }
      else { b.setAttribute('data-id', item.id); b.innerHTML = '<span class="ncp__timg"><img src="' + item.thumb + '" alt="" loading="lazy" draggable="false"></span><span class="ncp__tname">' + esc(item.title) + '</span><span class="ncp__tprice">' + esc(item.price_fmt) + '</span>'; }
      b.addEventListener('click', function () { choose(slot, item); });
      return b;
    }
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function buildLists() {
      ['top', 'bottom'].forEach(function (slot) {
        var list = $('[data-ncp-list="' + slot + '"]'); list.innerHTML = '';
        list.appendChild(tile(null, slot));
        (slot === 'top' ? DATA.tops : DATA.bottoms).forEach(function (it) { list.appendChild(tile(it, slot)); });
      });
    }
    function renderSel() {
      ['top', 'bottom'].forEach(function (slot) {
        var it = chosen[slot];
        $('[data-ncp-list="' + slot + '"]').querySelectorAll('.ncp__tile').forEach(function (t) { t.setAttribute('aria-pressed', String((it ? String(it.id) : 'none') === t.getAttribute('data-id'))); });
        var sz = $('[data-ncp-sizes="' + slot + '"]'); sz.innerHTML = '';
        if (it && it.variants && it.variants.length > 1) {
          it.variants.forEach(function (v) {
            var b = document.createElement('button'); b.type = 'button'; b.textContent = v.title; b.disabled = !v.available;
            b.setAttribute('aria-pressed', String(sizeSel[slot] === v.id));
            b.addEventListener('click', function () { sizeSel[slot] = v.id; renderSel(); }); sz.appendChild(b);
          });
        }
        el.querySelectorAll('[data-ncp-read="' + slot + '"]').forEach(function (rd) { rd.textContent = it ? it.title : '—'; });
      });
      var total = 0, sample = '', n = 0;
      ['top', 'bottom'].forEach(function (s) { if (chosen[s]) { total += chosen[s].price; sample = sample || chosen[s].price_fmt; n++; } });
      var tt = $('[data-ncp-total]'); if (tt) tt.textContent = n ? money(sample, total) : '—';
      var add = $('[data-ncp-add]'); if (add) { add.disabled = !n; }
    }
    function firstAvail(it) { if (!it || !it.variants) return null; for (var i = 0; i < it.variants.length; i++) if (it.variants[i].available) return it.variants[i].id; return it.variants.length ? it.variants[0].id : null; }
    function choose(slot, item) {
      chosen[slot] = item; sizeSel[slot] = item ? firstAvail(item) : null; renderSel(); wear(slot, item); idle = 0;
    }

    /* ---------- three bootstrap ---------- */
    function boot() {
      T = THREE;
      renderer = new T.WebGLRenderer({ antialias: true, alpha: true });
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
      renderer.outputEncoding = T.sRGBEncoding; renderer.localClippingEnabled = true;
      renderer.toneMapping = T.ACESFilmicToneMapping; renderer.toneMappingExposure = theme === 'dark' ? 1.05 : 1.0;
      view.insertBefore(renderer.domElement, view.firstChild);
      scene = new T.Scene();
      camera = new T.PerspectiveCamera(30, 1, .1, 50); camera.position.set(0, .98, 5.0); camera.lookAt(0, .8, 0);
      scene.add(new T.HemisphereLight(0xffffff, theme === 'dark' ? 0x20243a : 0xb9bcc6, theme === 'dark' ? .8 : .95));
      var key = new T.DirectionalLight(0xffffff, .8); key.position.set(2.5, 3.5, 3.5); scene.add(key);
      var rim = new T.PointLight(new T.Color(accent), 1.1, 9); rim.position.set(-2.2, 1.8, -2.4); scene.add(rim);
      var rim2 = new T.PointLight(new T.Color(accent), .7, 9); rim2.position.set(2.4, 1.2, -2.0); scene.add(rim2);
      root = new T.Group(); scene.add(root);
      try { makeEnv(); } catch (e) { }
      buildMannequin(); buildStage();
      function resize() { var w = view.clientWidth, h = view.clientHeight; if (!w || !h) return; renderer.setSize(w, h, false); camera.aspect = w / h; camera.updateProjectionMatrix(); }
      if (window.ResizeObserver) new ResizeObserver(resize).observe(view); resize(); window.addEventListener('resize', resize);
      bindPointer(); bindUI();
      var lo = $('[data-ncp-loading]'); if (lo) lo.classList.add('is-off');
      // default look
      if (DATA.tops.length) choose('top', DATA.tops[0]); else renderSel();
      if (DATA.bottoms.length) choose('bottom', DATA.bottoms[0]); else renderSel();
      var vis = true;
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { vis = es[0].isIntersecting; }, { rootMargin: '120px' }).observe(el);
      (function frame() {
        requestAnimationFrame(frame); if (!vis) { last = performance.now(); return; }
        step();
      })();
    }

    function makeEnv() {
      var pm = new T.PMREMGenerator(renderer), es = new T.Scene();
      var g = new T.SphereGeometry(10, 32, 16), cols = [], pos = g.attributes.position;
      for (var i = 0; i < pos.count; i++) { var y = pos.getY(i) / 10, c = new T.Color(); if (theme === 'dark') c.setRGB(.05 + .1 * (y * .5 + .5), .06 + .12 * (y * .5 + .5), .12 + .25 * (y * .5 + .5)); else c.setRGB(.55 + .4 * (y * .5 + .5), .56 + .4 * (y * .5 + .5), .6 + .38 * (y * .5 + .5)); cols.push(c.r, c.g, c.b); }
      g.setAttribute('color', new T.Float32BufferAttribute(cols, 3));
      es.add(new T.Mesh(g, new T.MeshBasicMaterial({ vertexColors: true, side: T.BackSide })));
      function panel(w, h, x, y, z, col, k) { var m = new T.Mesh(new T.PlaneGeometry(w, h), new T.MeshBasicMaterial({ color: new T.Color(col).multiplyScalar(k), side: T.DoubleSide })); m.position.set(x, y, z); m.lookAt(0, 0, 0); es.add(m); }
      panel(7, 3, 0, 6, 2, 0xffffff, 3.5); panel(2.5, 7, -7, 1, 2, 0xffffff, 2.5); panel(2, 6, 7, 2, -3, new T.Color(accent), 3); panel(5, 2, 0, -3, 5, 0xffffff, 1.2);
      var rt = pm.fromScene(es, .02); scene.environment = rt.texture; pm.dispose();
    }

    /* ---------- mannequin ---------- */
    var FIN = {
      pearl: { color: 0xeceef3, rough: .26, metal: .05, cc: 1 },
      chrome: { color: 0xd8dbe3, rough: .1, metal: 1, cc: 0 },
      onyx: { color: 0x16171c, rough: .24, metal: .55, cc: 1 }
    };
    function bodyMat() { var m = new T.MeshPhysicalMaterial({ color: 0xeceef3, roughness: .26, metalness: .05, clearcoat: 1, clearcoatRoughness: .12, envMapIntensity: 1.1 }); bodyMats.push(m); return m; }
    function setFinish(n) {
      var f = FIN[n] || FIN.pearl;
      bodyMats.forEach(function (m) { m.color.setHex(f.color); m.roughness = f.rough; m.metalness = f.metal; m.clearcoat = f.cc; m.needsUpdate = true; });
      el.setAttribute('data-finish', n);
      el.querySelectorAll('[data-ncp-finish]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-ncp-finish') === n)); });
    }
    var glowMat;
    function buildMannequin() {
      var mm = bodyMat();
      glowMat = new T.MeshBasicMaterial({ color: new T.Color(accent) });
      function lathe(p, seg) { return new T.Mesh(new T.LatheGeometry(p.map(function (q) { return new T.Vector2(q[0], q[1]); }), seg || 48), mm); }
      var torso = lathe([[0, .93], [.15, .95], [.17, 1.05], [.152, 1.2], [.162, 1.34], [.168, 1.4], [.1, 1.45], [.055, 1.5], [.052, 1.57], [0, 1.58]]); torso.scale.z = .5; root.add(torso);
      var pelvis = lathe([[0, .70], [.13, .72], [.165, .82], [.158, .94]]); pelvis.scale.z = .55; root.add(pelvis);
      var head = new T.Mesh(new T.SphereGeometry(.1, 48, 32), mm); head.scale.set(.88, 1.2, 1); head.position.set(0, 1.7, .006); root.add(head);
      // visor band + neck ring
      var visor = new T.Mesh(new T.TorusGeometry(.1, .004, 8, 64, Math.PI * 1.1), glowMat); visor.rotation.set(Math.PI / 2, 0, -Math.PI * .05); visor.rotation.x = Math.PI / 2; visor.position.set(0, 1.715, .004); visor.scale.set(.88, 1, 1.04); visor.rotation.z = Math.PI * 1.45; root.add(visor);
      var neck = new T.Mesh(new T.TorusGeometry(.062, .006, 10, 48), glowMat); neck.rotation.x = Math.PI / 2; neck.position.y = 1.545; root.add(neck);
      // legs
      [-1, 1].forEach(function (s) {
        var up = new T.Mesh(new T.CylinderGeometry(.072, .055, .5, 36), mm); up.position.set(s * .12, .72, 0); up.scale.z = .95; root.add(up);
        var lo = new T.Mesh(new T.CylinderGeometry(.052, .04, .46, 36), mm); lo.position.set(s * .12, .24, 0); lo.scale.z = .95; root.add(lo);
        var knee = new T.Mesh(new T.SphereGeometry(.058, 24, 16), mm); knee.position.set(s * .12, .47, 0); root.add(knee);
        var kr = new T.Mesh(new T.TorusGeometry(.059, .004, 8, 40), glowMat); kr.rotation.x = Math.PI / 2; kr.position.set(s * .12, .47, 0); root.add(kr);
      });
      // arms (only when there is no top)
      arms = new T.Group();
      [-1, 1].forEach(function (s) {
        var a = new T.Group(); a.position.set(s * .2, 1.4, 0); a.rotation.z = s * .12;
        var sh = new T.Mesh(new T.SphereGeometry(.052, 24, 16), mm); a.add(sh);
        var u = new T.Mesh(new T.CylinderGeometry(.043, .036, .3, 28), mm); u.position.y = -.17; a.add(u);
        var el2 = new T.Mesh(new T.SphereGeometry(.037, 20, 14), mm); el2.position.y = -.33; a.add(el2);
        var er = new T.Mesh(new T.TorusGeometry(.039, .0035, 8, 32), glowMat); er.rotation.x = Math.PI / 2; er.position.y = -.33; a.add(er);
        var f = new T.Mesh(new T.CylinderGeometry(.034, .026, .27, 28), mm); f.position.y = -.48; a.add(f);
        var h = new T.Mesh(new T.SphereGeometry(.032, 18, 12), mm); h.scale.set(.8, 1.4, .6); h.position.y = -.65; a.add(h);
        arms.add(a);
      });
      root.add(arms);
      setFinish(el.getAttribute('data-finish') || 'pearl');
    }

    /* ---------- stage: platform, rings, particles, scan ---------- */
    function blob(col) { var c = document.createElement('canvas'); c.width = c.height = 128; var x = c.getContext('2d'), g = x.createRadialGradient(64, 64, 4, 64, 64, 62); g.addColorStop(0, col); g.addColorStop(1, 'rgba(0,0,0,0)'); x.fillStyle = g; x.fillRect(0, 0, 128, 128); var t = new T.CanvasTexture(c); return t; }
    function buildStage() {
      var dark = theme === 'dark';
      var base = new T.Mesh(new T.CylinderGeometry(.62, .66, .035, 96), new T.MeshPhysicalMaterial({ color: dark ? 0x0c0e16 : 0xf6f7fa, roughness: .22, metalness: dark ? .6 : .1, clearcoat: 1, envMapIntensity: 1 })); base.position.y = -.0175; root.add(base);
      var edge = new T.Mesh(new T.TorusGeometry(.64, .006, 8, 128), glowMat); edge.rotation.x = Math.PI / 2; edge.position.y = .002; root.add(edge);
      var sh = new T.Mesh(new T.PlaneGeometry(1.9, 1.9), new T.MeshBasicMaterial({ map: blob(dark ? 'rgba(43,78,255,.35)' : 'rgba(10,12,30,.28)'), transparent: true, depthWrite: false })); sh.rotation.x = -Math.PI / 2; sh.position.y = -.03; scene.add(sh);
      for (var i = 0; i < 3; i++) { var r = new T.Mesh(new T.RingGeometry(.66, .675, 96), new T.MeshBasicMaterial({ color: new T.Color(accent), transparent: true, opacity: .0, side: T.DoubleSide, depthWrite: false })); r.rotation.x = -Math.PI / 2; r.position.y = -.025; r.userData.ph = i / 3; scene.add(r); floorRings.push(r); }
      // dashed rotating ring
      var dash = new T.Mesh(new T.RingGeometry(.9, .905, 128, 1), new T.MeshBasicMaterial({ color: new T.Color(accent), transparent: true, opacity: .35, side: T.DoubleSide, depthWrite: false })); dash.rotation.x = -Math.PI / 2; dash.position.y = -.026; scene.add(dash);
      var ticks = new T.Group(); for (var k = 0; k < 72; k++) { var tk = new T.Mesh(new T.PlaneGeometry(.006, k % 6 === 0 ? .06 : .028), new T.MeshBasicMaterial({ color: new T.Color(accent), transparent: true, opacity: k % 6 === 0 ? .9 : .45, side: T.DoubleSide, depthWrite: false })); var an = k / 72 * Math.PI * 2; tk.position.set(Math.cos(an) * .78, 0, Math.sin(an) * .78); tk.rotation.set(-Math.PI / 2, 0, -an + Math.PI / 2); ticks.add(tk); }
      ticks.position.y = -.024; scene.add(ticks); stage.ticks = ticks;
      // particles
      var N = 140, p = new Float32Array(N * 3), ph = new Float32Array(N);
      for (var j = 0; j < N; j++) { var a2 = Math.random() * Math.PI * 2, rr = .5 + Math.random() * 1.1; p[j * 3] = Math.cos(a2) * rr; p[j * 3 + 1] = Math.random() * 2.3; p[j * 3 + 2] = Math.sin(a2) * rr * .8; ph[j] = Math.random() * 6; }
      var pg = new T.BufferGeometry(); pg.setAttribute('position', new T.BufferAttribute(p, 3));
      particles = new T.Points(pg, new T.PointsMaterial({ color: new T.Color(accent), size: .022, transparent: true, opacity: dark ? .9 : .65, depthWrite: false, sizeAttenuation: true })); particles.userData.ph = ph; scene.add(particles);
      // scan ring
      scanPlane = new T.Plane(new T.Vector3(0, -1, 0), 0);
      scanRing = new T.Mesh(new T.TorusGeometry(.5, .006, 8, 128), new T.MeshBasicMaterial({ color: new T.Color(accent) })); scanRing.rotation.x = Math.PI / 2; scanRing.visible = false; scene.add(scanRing);
      scanDisc = new T.Mesh(new T.CircleGeometry(.5, 64), new T.MeshBasicMaterial({ color: new T.Color(accent), transparent: true, opacity: .12, side: T.DoubleSide, depthWrite: false })); scanDisc.rotation.x = Math.PI / 2; scanDisc.visible = false; scene.add(scanDisc);
      // zip slider
      var sm = new T.MeshPhongMaterial({ color: 0x2b2e36, specular: 0x9aa4ff, shininess: 120 });
      slider = new T.Mesh(new T.BoxGeometry(.024, .036, .012), sm);
      var tab = new T.Mesh(new T.BoxGeometry(.013, .05, .005), sm); tab.position.set(0, -.045, .004); slider.add(tab);
      var hit = new T.Mesh(new T.BoxGeometry(.12, .16, .08), new T.MeshBasicMaterial({ visible: false })); slider.add(hit); slider.userData.hit = hit; slider.visible = false; root.add(slider);
    }
    var stage = {};

    /* ---------- garments ---------- */
    function loadImg(src) {
      if (imgCache[src]) return imgCache[src];
      return imgCache[src] = new Promise(function (r) { var i = new Image(); i.crossOrigin = 'anonymous'; i.onload = function () { r(i); }; i.onerror = function () { r(null); }; i.src = src; });
    }
    function bboxOf(img) {
      var c = document.createElement('canvas'), mw = 300, k = mw / img.width; c.width = mw; c.height = Math.round(img.height * k);
      var x = c.getContext('2d'); x.drawImage(img, 0, 0, c.width, c.height); var d = x.getImageData(0, 0, c.width, c.height).data, a = 1e9, b = 1e9, e = -1, f = -1;
      for (var y = 0; y < c.height; y++) for (var xx = 0; xx < c.width; xx++) if (d[(y * c.width + xx) * 4 + 3] > 20) { if (xx < a) a = xx; if (xx > e) e = xx; if (y < b) b = y; if (y > f) f = y; }
      if (e < 0) return { x: 0, y: 0, w: img.width, h: img.height };
      return { x: a / k, y: b / k, w: (e - a + 1) / k, h: (f - b + 1) / k };
    }
    function crop(img, bb, W, H) { var c = document.createElement('canvas'); c.width = W; c.height = H; c.getContext('2d').drawImage(img, bb.x, bb.y, bb.w, bb.h, 0, 0, W, H); return c; }
    function tex(c) { var t = new T.CanvasTexture(c); t.encoding = T.sRGBEncoding; t.anisotropy = Math.min(8, renderer.capabilities.getMaxAnisotropy()); return t; }

    function makeGarment(cfg) {
      var gx = cfg.gx, gy = cfg.gy, W = cfg.W, H = cfg.H, thick = cfg.thick, cy = cfg.cy, zoff = cfg.zoff, split = cfg.split, maskCanvas = cfg.maskCanvas;
      var cm = (gx - 1) / 2, NX = split ? gx + 1 : gx;
      var xs = new Float32Array(gx), ys = new Float32Array(gy), i, j, k;
      for (i = 0; i < gx; i++) xs[i] = -W / 2 + W * i / (gx - 1); for (j = 0; j < gy; j++) ys[j] = -H / 2 + H * j / (gy - 1);
      var mw = maskCanvas.width, mh = maskCanvas.height, md = maskCanvas.getContext('2d').getImageData(0, 0, mw, mh).data;
      function alphaAt(u, v) { var px = clamp(Math.round(u * (mw - 1)), 0, mw - 1), py = clamp(Math.round((1 - v) * (mh - 1)), 0, mh - 1); return md[(py * mw + px) * 4 + 3] / 255; }
      var inside = new Uint8Array(gx * gy), dist = new Float32Array(gx * gy);
      for (j = 0; j < gy; j++) for (i = 0; i < gx; i++) inside[j * gx + i] = alphaAt(i / (gx - 1), j / (gy - 1)) > .5 ? 1 : 0;
      for (k = 0; k < dist.length; k++) dist[k] = inside[k] ? 1e4 : 0;
      for (j = 0; j < gy; j++) for (i = 0; i < gx; i++) { k = j * gx + i; if (!inside[k]) continue; var d = dist[k]; if (i == 0 || j == 0 || i == gx - 1 || j == gy - 1) d = 1; if (i > 0) d = Math.min(d, dist[k - 1] + 1); if (j > 0) d = Math.min(d, dist[k - gx] + 1); dist[k] = d; }
      for (j = gy - 1; j >= 0; j--) for (i = gx - 1; i >= 0; i--) { k = j * gx + i; if (!inside[k]) continue; var d2 = dist[k]; if (i < gx - 1) d2 = Math.min(d2, dist[k + 1] + 1); if (j < gy - 1) d2 = Math.min(d2, dist[k + gx] + 1); dist[k] = d2; }
      var dmax = 1; for (k = 0; k < dist.length; k++) if (dist[k] < 1e4 && dist[k] > dmax) dmax = dist[k];
      var zf = new Float32Array(gx * gy), edge = new Float32Array(gx * gy);
      for (k = 0; k < edge.length; k++) edge[k] = Math.pow(Math.min(dist[k] / Math.max(dmax * .35, 1), 1), .5);
      if (cfg.profile === 'rows') {
        for (j = 0; j < gy; j++) { i = 0; while (i < gx) { if (!inside[j * gx + i]) { i++; continue; } var a = i; while (i < gx && inside[j * gx + i]) i++; var b = i - 1, c = (xs[a] + xs[b]) / 2, h = (xs[b] - xs[a]) / 2 + W / (gx - 1); for (var q = a; q <= b; q++) { var u = (xs[q] - c) / h; zf[j * gx + q] = thick * Math.sqrt(Math.max(1 - u * u, 0)); } } }
      } else {
        var bw = cfg.bodyHW;
        for (j = 0; j < gy; j++) for (i = 0; i < gx; i++) { k = j * gx + i; if (!inside[k]) continue; var uu = xs[i] / bw, tb = thick * Math.sqrt(Math.max(1 - uu * uu, 0)); zf[k] = Math.max(tb * edge[k], .03 * Math.min(dist[k] / 3, 1)); }
      }
      for (var p = 0; p < 4; p++) { var t2 = zf.slice(); for (j = 1; j < gy - 1; j++) for (i = 1; i < gx - 1; i++) { k = j * gx + i; if (inside[k]) zf[k] = (t2[k] * 2 + t2[k - 1] + t2[k + 1] + t2[k - gx] + t2[k + gx]) / 6; } }
      for (k = 0; k < zf.length; k++) zf[k] += zoff;
      var colMap = []; for (var cc = 0; cc < NX; cc++) colMap.push(split ? (cc <= cm ? cc : cc - 1) : cc);
      function layer(front) {
        var n = NX * gy, pos = new Float32Array(n * 3), uv = new Float32Array(n * 2), idx = [], jj, c2;
        for (jj = 0; jj < gy; jj++) for (c2 = 0; c2 < NX; c2++) { var i2 = colMap[c2], v = jj * NX + c2, u2 = i2 / (gx - 1); uv[v * 2] = front ? u2 : 1 - u2; uv[v * 2 + 1] = jj / (gy - 1); }
        for (jj = 0; jj < gy - 1; jj++) for (c2 = 0; c2 < NX - 1; c2++) {
          if (split && front && c2 == cm) continue;
          var i0 = colMap[c2], i1 = colMap[c2 + 1], uc = (i0 + i1 + 1) / 2 / (gx - 1), vc = (jj + .5) / (gy - 1), du = .6 / (gx - 1), dv = .6 / (gy - 1);
          if (Math.max(alphaAt(uc, vc), alphaAt(uc - du, vc - dv), alphaAt(uc + du, vc - dv), alphaAt(uc - du, vc + dv), alphaAt(uc + du, vc + dv)) < .1) continue;
          var a2 = jj * NX + c2, b2 = a2 + 1, d3 = a2 + NX, e2 = d3 + 1;
          if (front) idx.push(a2, b2, e2, a2, e2, d3); else idx.push(a2, e2, b2, a2, d3, e2);
        }
        var g = new T.BufferGeometry(); g.setAttribute('position', new T.BufferAttribute(pos, 3)); g.setAttribute('uv', new T.BufferAttribute(uv, 2)); g.setIndex(idx); return g;
      }
      var gF = layer(true), gB = layer(false);
      // side wall: closes the gap between front and back along the silhouette
      var K = new Uint8Array((NX - 1) * (gy - 1)), jj0, c0;
      for (jj0 = 0; jj0 < gy - 1; jj0++) for (c0 = 0; c0 < NX - 1; c0++) {
        var q0 = colMap[c0], q1 = colMap[c0 + 1], uc0 = (q0 + q1 + 1) / 2 / (gx - 1), vc0 = (jj0 + .5) / (gy - 1), du0 = .6 / (gx - 1), dv0 = .6 / (gy - 1);
        K[jj0 * (NX - 1) + c0] = (inside[jj0 * gx + q0] && inside[jj0 * gx + q1] && inside[(jj0 + 1) * gx + q0] && inside[(jj0 + 1) * gx + q1]) ? 1 : 0;
      }
      function kp(jx, cx) { return jx >= 0 && jx < gy - 1 && cx >= 0 && cx < NX - 1 && K[jx * (NX - 1) + cx] === 1; }
      var wedges = [];
      for (jj0 = 0; jj0 < gy - 1; jj0++) for (c0 = 0; c0 < NX - 1; c0++) {
        if (!kp(jj0, c0)) continue; var a0 = jj0 * NX + c0, b0 = a0 + 1, d0 = a0 + NX, e0 = d0 + 1;
        if (!kp(jj0, c0 - 1)) wedges.push(a0, d0); if (!kp(jj0, c0 + 1)) wedges.push(b0, e0);
        if (!kp(jj0 - 1, c0)) wedges.push(a0, b0); if (!kp(jj0 + 1, c0)) wedges.push(d0, e0);
      }
      var nW = wedges.length / 2, wpos = new Float32Array(nW * 12), widx = [];
      for (var wq = 0; wq < nW; wq++) widx.push(wq * 4, wq * 4 + 1, wq * 4 + 2, wq * 4, wq * 4 + 2, wq * 4 + 3);
      var gW = new T.BufferGeometry(); gW.setAttribute('position', new T.BufferAttribute(wpos, 3)); gW.setIndex(widx);
      var wallMat = new T.MeshLambertMaterial({ color: cfg.wallColor || 0x222226, side: T.DoubleSide });
      function mk(c) { return new T.MeshLambertMaterial({ alphaTest: .5, alphaToCoverage: true, side: T.FrontSide, color: c || 0xffffff }); }
      var group = new T.Group(); group.position.y = cy;
      var mF = new T.Mesh(gF, mk()), mB = new T.Mesh(gB, mk());
      var mats = [mF.material, mB.material, wallMat]; group.add(mF, mB); var mW = new T.Mesh(gW, wallMat); group.add(mW);
      var linB;
      if (cfg.liners) {
        linB = new T.Mesh(gB, new T.MeshLambertMaterial({ color: 0x17171b, side: T.BackSide, alphaTest: .5, polygonOffset: true, polygonOffsetFactor: 2, polygonOffsetUnits: 2 }));
        group.add(linB); mats.push(linB.material);
      }
      var N = gx * gy, L = new Float32Array(N); for (j = 0; j < gy; j++) for (i = 0; i < gx; i++) L[j * gx + i] = cfg.loose(xs[i], ys[j], W, H);
      var G = { wedges: wedges, gW: gW, group: group, mF: mF, mB: mB, linB: linB, gF: gF, gB: gB, xs: xs, ys: ys, zf: zf, gx: gx, gy: gy, NX: NX, colMap: colMap, cm: cm, split: split, d: new Float32Array(N * 3), v: new Float32Array(N * 3), tmp: new Float32Array(N * 3), L: L, W: W, H: H, cy: cy, mats: mats,
        setTex: function (f, b) { mF.material.map = f; mB.material.map = b; if (linB) { linB.material.map = b; } mats.forEach(function (m) { m.needsUpdate = true; }); },
        dispose: function () { gF.dispose(); gB.dispose(); gW.dispose(); mats.forEach(function (m) { if (m.map) m.map.dispose(); m.dispose(); }); } };
      return G;
    }
    function physics(G, dt, al, om, tm) {
      var d = G.d, v = G.v, tmp = G.tmp, L = G.L, xs = G.xs, ys = G.ys, zf = G.zf, gx = G.gx, gy = G.gy, i, j;
      for (j = 0; j < gy; j++) for (i = 0; i < gx; i++) {
        var k = j * gx + i, l = L[k]; if (l < .002) { d[k * 3] = d[k * 3 + 1] = d[k * 3 + 2] = 0; continue; }
        var x = xs[i], z = zf[k] * .6, kk = 620 * (1 - l) + 34 * l, cc = 2 * Math.sqrt(kk) * .16;
        var fx = (-al * z + om * om * x * .8) * .26 * l + Math.sin(tm * 1.7 + ys[j] * 5 + x * 4) * .012 * l;
        var fz = (al * x + om * om * z * .8) * .26 * l + Math.sin(tm * 1.3 + x * 6 + ys[j] * 3) * .012 * l;
        var fy = -.35 * l * Math.min(Math.abs(om), 6) * .12, o = k * 3;
        v[o] += (-kk * d[o] - cc * v[o] + fx) * dt; v[o + 1] += (-kk * d[o + 1] - cc * v[o + 1] + fy) * dt; v[o + 2] += (-kk * d[o + 2] - cc * v[o + 2] + fz) * dt;
        d[o] += v[o] * dt; d[o + 1] += v[o + 1] * dt; d[o + 2] += v[o + 2] * dt;
        for (var a = 0; a < 3; a++) d[o + a] = clamp(d[o + a], -.16, .16);
      }
      tmp.set(d);
      for (j = 1; j < gy - 1; j++) for (i = 1; i < gx - 1; i++) { var k2 = (j * gx + i) * 3, a1 = k2 - 3, b1 = k2 + 3, c1 = k2 - gx * 3, e1 = k2 + gx * 3; for (var q = 0; q < 3; q++) d[k2 + q] = tmp[k2 + q] + .35 * ((tmp[a1 + q] + tmp[b1 + q] + tmp[c1 + q] + tmp[e1 + q]) / 4 - tmp[k2 + q]); }
    }
    function writeGeometry(G, zip) {
      var gF = G.gF, gB = G.gB, xs = G.xs, ys = G.ys, zf = G.zf, gx = G.gx, gy = G.gy, NX = G.NX, colMap = G.colMap, d = G.d;
      var pf = gF.attributes.position.array, pb = gB.attributes.position.array;
      for (var j = 0; j < gy; j++) for (var c = 0; c < NX; c++) {
        var i = colMap[c], k = j * gx + i, o = (j * NX + c) * 3, dk = k * 3, x = xs[i], y = ys[j], zz = zf[k], zx = 0, zz2 = 0;
        if (zip && G.split) { var q = zip(c, i, x, y); zx = q[0]; zz2 = q[1]; }
        pf[o] = x + d[dk] + zx; pf[o + 1] = y + d[dk + 1]; pf[o + 2] = zz + d[dk + 2] + zz2;
        pb[o] = x + d[dk]; pb[o + 1] = y + d[dk + 1]; pb[o + 2] = -zz + d[dk + 2];
      }
      var we = G.wedges, wp = G.gW.attributes.position.array, n = we.length / 2;
      for (var e = 0; e < n; e++) { var vA = we[e * 2] * 3, vB = we[e * 2 + 1] * 3, o2 = e * 12;
        wp[o2] = pf[vA]; wp[o2 + 1] = pf[vA + 1]; wp[o2 + 2] = pf[vA + 2]; wp[o2 + 3] = pf[vB]; wp[o2 + 4] = pf[vB + 1]; wp[o2 + 5] = pf[vB + 2];
        wp[o2 + 6] = pb[vB]; wp[o2 + 7] = pb[vB + 1]; wp[o2 + 8] = pb[vB + 2]; wp[o2 + 9] = pb[vA]; wp[o2 + 10] = pb[vA + 1]; wp[o2 + 11] = pb[vA + 2]; }
      G.gW.attributes.position.needsUpdate = true; G.gW.computeVertexNormals();
      gF.attributes.position.needsUpdate = true; gB.attributes.position.needsUpdate = true; gF.computeVertexNormals(); gB.computeVertexNormals();
    }
    function looseFn(x, y, W, H) { var ty = (y + H / 2) / H, hem = Math.pow(clamp((.62 - ty) / .62, 0, 1), 1.2), sl = sstep(.34, .5, Math.abs(x) / (W / 2)) * .7; return clamp(Math.max(hem * .85, sl), 0, 1); }

    function avgColor(c) {
      var t = document.createElement('canvas'); t.width = t.height = 24; var x = t.getContext('2d'); x.drawImage(c, 0, 0, 24, 24); var d = x.getImageData(0, 0, 24, 24).data, r = 0, g = 0, b = 0, n = 0;
      for (var i = 0; i < d.length; i += 4) if (d[i + 3] > 240) { r += d[i]; g += d[i + 1]; b += d[i + 2]; n++; }
      if (!n) return 0x222226; return (Math.round(r / n * .8) << 16) | (Math.round(g / n * .8) << 8) | Math.round(b / n * .8);
    }
    function build(item, kind, fimg, bimg) {
      var fb = bboxOf(fimg), bb = bimg ? bboxOf(bimg) : fb, asp = fb.w / fb.h, cfg;
      var fc, bc, TW = 820, TH = Math.round(TW / asp);
      if (TH > 2000) { TH = 2000; TW = Math.round(TH * asp); }
      if (kind === 'pants') {
        var PH = 1.0, PW = PH * asp; fc = crop(fimg, fb, TW, TH); bc = bimg ? crop(bimg, bb, TW, TH) : fc;
        cfg = { gx: 65, gy: 113, W: PW, H: PH, thick: .095, profile: 'rows', cy: .03 + PH / 2, zoff: 0, split: false, maskCanvas: crop(fimg, fb, fb.w > 700 ? 700 : fb.w, Math.round((fb.w > 700 ? 700 : fb.w) / asp)), liners: false, wallColor: avgColor(fc), loose: function (x, y, W, H) { var ty = (y + H / 2) / H; return clamp(Math.pow(clamp((.86 - ty) / .86, 0, 1), 1.1) * .95, 0, 1); } };
      } else {
        var isH = kind === 'hoodie', HH = isH ? HOOD.H : .62, HW = HH * asp, top = isH ? HOOD.top : 1.5;
        fc = crop(fimg, fb, TW, TH); bc = bimg ? crop(bimg, bb, TW, TH) : fc;
        cfg = { gx: isH ? 81 : 73, gy: isH ? 97 : 79, W: HW, H: HH, thick: isH ? .17 : .15, bodyHW: HW * .29, profile: 'body', cy: top - HH / 2, zoff: .012, split: isH && !!item.zip, maskCanvas: crop(fimg, fb, 600, Math.round(600 / asp)), liners: isH, wallColor: avgColor(fc), loose: looseFn };
      }
      var G = makeGarment(cfg); G.setTex(tex(fc), tex(bc)); return G;
    }

    function reveal(G) {
      G.mats.forEach(function (m) { m.clippingPlanes = [scanPlane]; m.needsUpdate = true; });
      scanning = 1; stage.scanT = 0; stage.scanG = G; scanRing.visible = scanDisc.visible = true;
    }
    function wearToken() { return ++wearToken.n; } wearToken.n = 0;
    var tokens = { top: 0, bottom: 0 };
    function wear(slot, item) {
      var my = ++tokens[slot];
      if (worn[slot]) { root.remove(worn[slot].G.group); worn[slot].G.dispose(); worn[slot] = null; }
      if (slot === 'top') { arms.visible = !item; slider.visible = false; }
      if (!item) return;
      var kind = slot === 'bottom' ? 'pants' : item.kind;
      Promise.all([loadImg(item.front), item.back ? loadImg(item.back) : Promise.resolve(null)]).then(function (im) {
        if (my !== tokens[slot] || !im[0]) return;
        var G = build(item, kind, im[0], im[1]);
        worn[slot] = { G: G, item: item, zip: slot === 'top' && kind === 'hoodie' && !!item.zip };
        root.add(G.group); G.group.updateMatrixWorld(true);
        if (worn[slot].zip) { zipY = zipT = ZTOP; }
        reveal(G);
        var zb = $('[data-ncp-zip]'); if (zb) zb.hidden = !(worn.top && worn.top.zip);
      });
    }

    /* ---------- zip ---------- */
    function zipFn(c, i, x, y) {
      var T0 = worn.top; if (!T0) return [0, 0]; var G = T0.G;
      var yw = G.group.position.y + y, open = yw - zipY; if (open <= 0) return [0, 0];
      var s = sstep(0, .09, open) * (.3 + .7 * clamp(open / .5, 0, 1)), side = c <= G.cm ? -1 : 1, rel = Math.abs(x) / (G.W / 2), fall = Math.pow(1 - clamp(rel / .95, 0, 1), 1.2);
      return [side * .17 * s * fall, -.07 * s * fall * clamp(rel * 3, 0, 1)];
    }
    function setSlider() {
      var T0 = worn.top; if (!T0 || !T0.zip) { slider.visible = false; return; } var G = T0.G; slider.visible = true;
      var k = (Math.round(clamp((zipY - G.group.position.y + G.H / 2) / G.H, 0, 1) * (G.gy - 1))) * G.gx + G.cm | 0, o = k * 3;
      slider.position.set(G.d[o], zipY + G.d[o + 1], G.zf[k] + G.d[o + 2] + .012); slider.updateMatrixWorld();
    }

    /* ---------- interaction ---------- */
    var ray, ndc;
    function bindPointer() {
      ray = new T.Raycaster(); ndc = new T.Vector2();
      function toNDC(e) { var r = renderer.domElement.getBoundingClientRect(); ndc.set((e.clientX - r.left) / r.width * 2 - 1, -((e.clientY - r.top) / r.height) * 2 + 1); }
      view.addEventListener('pointerdown', function (e) {
        if (e.target.closest('button')) return;
        toNDC(e); ray.setFromCamera(ndc, camera); var hit = slider.visible ? ray.intersectObject(slider.userData.hit, false) : [];
        try { view.setPointerCapture(e.pointerId); } catch (x) { }
        if (hit.length && Math.cos(theta) > .35) dragZip = true; else { dragRot = true; view.classList.add('is-drag'); lastX = e.clientX; lastT = performance.now(); velX = 0; }
        idle = 0;
      });
      view.addEventListener('pointermove', function (e) {
        if (dragZip) { toNDC(e); ray.setFromCamera(ndc, camera); var pl = new T.Plane(new T.Vector3(0, 0, 1), -.14), p = new T.Vector3(), inv = new T.Matrix4().copy(root.matrixWorld).invert(), r2 = ray.ray.clone().applyMatrix4(inv); if (r2.intersectPlane(pl, p)) zipT = clamp(p.y, ZBOT, ZTOP); }
        else if (dragRot) { var now = performance.now(), dx = e.clientX - lastX; theta += dx * .012; velX = dx * .012 / Math.max((now - lastT) / 1000, .008); lastX = e.clientX; lastT = now; }
      });
      function end() { dragZip = false; if (dragRot) { dragRot = false; view.classList.remove('is-drag'); omega = clamp(velX, -9, 9); } }
      view.addEventListener('pointerup', end); view.addEventListener('pointercancel', end);
    }
    function bindUI() {
      el.querySelectorAll('[data-ncp-finish]').forEach(function (b) { b.addEventListener('click', function () { setFinish(b.getAttribute('data-ncp-finish')); }); });
      var zb = $('[data-ncp-zip]'); if (zb) { zb.hidden = true; zb.addEventListener('click', function () { zipT = zipT > (ZTOP + ZBOT) / 2 ? ZBOT : ZTOP; theta = Math.round(theta / (Math.PI * 2)) * Math.PI * 2; idle = 0; }); }
      var add = $('[data-ncp-add]'), msg = $('[data-ncp-msg]');
      if (add) add.addEventListener('click', function () {
        var items = []; ['top', 'bottom'].forEach(function (s) { if (chosen[s] && sizeSel[s]) items.push({ id: sizeSel[s], quantity: 1 }); });
        if (!items.length) return; add.disabled = true; var old = add.textContent; add.textContent = 'Añadiendo…';
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) throw 0; return r.json(); })
          .then(function () { add.textContent = 'Look añadido ✓'; if (msg) { msg.hidden = false; } document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true })); })
          .catch(function () { add.textContent = 'No se pudo añadir'; })
          .then(function () { setTimeout(function () { add.textContent = old; add.disabled = false; }, 2200); });
      });
    }

    /* ---------- loop ---------- */
    function step() {
      var now = performance.now(), dt = Math.min((now - last) / 1000, .05); last = now; time += dt; idle += dt;
      if (!dragRot) { if (idle > 2.5) { omega += (.45 - omega) * Math.min(dt * 1.2, 1); } else omega *= Math.pow(.05, dt); theta += omega * dt; } else { omega = velX; velX *= Math.pow(.02, dt); }
      alpha = clamp((omega - prevOmega) / Math.max(dt, .001), -60, 60); prevOmega = omega; root.rotation.y = theta;
      zipY += (zipT - zipY) * Math.min(dt * 10, 1);
      ['top', 'bottom'].forEach(function (s) { var w = worn[s]; if (!w) return; for (var q = 0; q < 2; q++) physics(w.G, dt / 2, alpha, omega, time); writeGeometry(w.G, s === 'top' ? zipFn : null); });
      var tw = worn.top; if (tw && tw.G.linB) tw.G.linB.visible = !!(tw.zip && (ZTOP - zipY) > .03);
      setSlider();
      // scan
      if (scanning) {
        stage.scanT += dt; var u = clamp(stage.scanT / 1.15, 0, 1), e = u * u * (3 - 2 * u), y = -.05 + e * 1.95; scanPlane.constant = y;
        scanRing.position.y = scanDisc.position.y = y; var s = 1 + Math.sin(u * Math.PI) * .12; scanRing.scale.set(s, s, 1); scanDisc.scale.set(s, s, 1);
        if (u >= 1) { scanning = 0; scanRing.visible = scanDisc.visible = false; ['top', 'bottom'].forEach(function (s2) { var w = worn[s2]; if (w) w.G.mats.forEach(function (m) { m.clippingPlanes = null; m.needsUpdate = true; }); }); }
      }
      floorRings.forEach(function (r) { var p = (time * .35 + r.userData.ph) % 1; var sc = 1 + p * .9; r.scale.set(sc, sc, 1); r.material.opacity = (1 - p) * .5; });
      if (stage.ticks) stage.ticks.rotation.y = -time * .2;
      var pa = particles.geometry.attributes.position.array, ph = particles.userData.ph;
      for (var i = 0; i < ph.length; i++) { pa[i * 3 + 1] += dt * (.05 + (ph[i] % 1) * .08); if (pa[i * 3 + 1] > 2.3) pa[i * 3 + 1] = 0; pa[i * 3] += Math.sin(time * .5 + ph[i]) * .0006; }
      particles.geometry.attributes.position.needsUpdate = true;
      camera.position.y = .98 + Math.sin(time * .4) * .015; camera.lookAt(0, .8, 0);
      renderer.render(scene, camera);
      if (fmtDeg) fmtDeg.textContent = (((Math.round(theta * 180 / Math.PI) % 360) + 360) % 360) + '°';
    }
    window.__ncp = { dbg: function () { return { scene: scene, root: root, worn: worn }; }, set: function (a) { theta = a; omega = 0; idle = -99; }, zip: function (y) { zipT = y; zipY = y; }, choose: choose, data: DATA };

    buildLists(); renderSel();
    loadThree().then(boot).catch(function () { var lo = $('[data-ncp-loading]'); if (lo) lo.textContent = 'No se pudo cargar el visor 3D.'; });
  }
  function start() { document.querySelectorAll('[data-ncp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nc-rail-3d"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.ready) return; root.dataset.ready = '1';
      var track = root.querySelector('[data-nc3d-track]'), prog = root.querySelector('[data-nc3d-prog]');
      var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      var items = Array.prototype.map.call(root.querySelectorAll('[data-nc3d-item]'), function (li, i) {
        var o = { li: li, sway: li.querySelector('[data-nc3d-sway]'), card: li.querySelector('[data-nc3d-card]'), side: 0, rx: 0, ry: 0, tx: 0, ty: 0, a: 0, v: 0, ph: i * 1.9 };
        var btns = li.querySelectorAll('.nc3d__flip button');
        var hasBack = li.querySelectorAll('.nc3d__face').length > 1;
        function set(s) { if (!hasBack) return; o.side = s; Array.prototype.forEach.call(btns, function (b) { b.setAttribute('aria-pressed', String(+b.dataset.side === s)); }); }
        Array.prototype.forEach.call(btns, function (b) { b.addEventListener('click', function () { set(+b.dataset.side); }); });
        o.card.addEventListener('click', function () { if (!track.classList.contains('is-dragging')) set(1 - o.side); });
        o.card.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); set(1 - o.side); } });
        o.card.addEventListener('pointermove', function (e) {
          if (e.pointerType === 'touch') return;
          var r = o.card.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
          o.tx = (x - .5) * 2; o.ty = (y - .5) * 2;
          Array.prototype.forEach.call(o.card.querySelectorAll('.nc3d__vol, .nc3d__gloss'), function (n) {
            n.style.setProperty('--lx', x * 100 + '%'); n.style.setProperty('--ly', y * 100 + '%'); n.style.setProperty('--sx', x * 100 + '%');
          });
        });
        o.card.addEventListener('pointerleave', function () { o.tx = 0; o.ty = 0; });
        return o;
      });
      var last = 0;
      function progress() {
        if (!prog) return;
        var sw = track.scrollWidth, cw = track.clientWidth;
        prog.style.width = Math.max(8, Math.min(100, cw / sw * 100)) + '%';
        prog.style.left = Math.max(0, Math.min(100, track.scrollLeft / sw * 100)) + '%';
      }
      track.addEventListener('scroll', function () {
        var d = track.scrollLeft - last; last = track.scrollLeft;
        items.forEach(function (o) { o.v += Math.max(-.6, Math.min(.6, d * .03)); });
        progress();
      }, { passive: true });
      progress();
      var down = false, moved = false, sx = 0, sl = 0;
      track.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button !== 0) return; down = true; moved = false; sx = e.clientX; sl = track.scrollLeft; });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx;
        if (!moved && Math.abs(dx) > 5) { moved = true; track.classList.add('is-dragging'); }
        if (moved) track.scrollLeft = sl - dx;
      });
      window.addEventListener('pointerup', function () { down = false; setTimeout(function () { track.classList.remove('is-dragging'); }, 0); });
      var t = 0;
      (function loop() {
        t += .016;
        items.forEach(function (o) {
          var rest = reduce ? 0 : Math.sin(t * .9 + o.ph) * .9;
          o.a += (rest - o.a) * .04 + o.v; o.v *= .9;
          o.sway.style.transform = 'rotate(' + o.a.toFixed(3) + 'deg)';
          o.rx += (o.ty * -7 - o.rx) * .1; o.ry += (o.tx * 9 - o.ry) * .1;
          o.card.style.transform = 'rotateY(' + (o.side * 180 + o.ry) + 'deg) rotateX(' + o.rx + 'deg)';
        });
        requestAnimationFrame(loop);
      })();
    }
    function boot() { document.querySelectorAll('[data-nc3d]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nc-rail"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var track = root.querySelector('[data-gr-track]');
      if (!track || root.dataset.grInit) return;
      root.dataset.grInit = '1';
      var prog = root.querySelector('[data-gr-progress]');
      var items = Array.prototype.map.call(root.querySelectorAll('[data-gr-item]'), function (li, i) {
        return { li: li, el: li.querySelector('[data-gr-sway]'), a: 0, v: 0, ph: i * 1.9 };
      });
      function progress() {
        if (!prog) return;
        var sw = track.scrollWidth, cw = track.clientWidth;
        prog.style.width = Math.max(5, Math.min(100, cw / sw * 100)) + '%';
        prog.style.left = Math.max(0, Math.min(100, track.scrollLeft / sw * 100)) + '%';
      }
      track.addEventListener('scroll', progress, { passive: true }); progress();
      var step = function () { return Math.max(240, track.clientWidth * 0.7); };
      var prev = root.querySelector('[data-gr-prev]'), next = root.querySelector('[data-gr-next]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('keydown', function (e) {
        if (e.target !== track) return;
        if (e.key === 'ArrowRight') track.scrollBy({ left: step() / 2, behavior: 'smooth' });
        if (e.key === 'ArrowLeft') track.scrollBy({ left: -step() / 2, behavior: 'smooth' });
      });
      /* mouse drag with momentum (touch uses native swipe) */
      var down = false, moved = false, sx = 0, sl = 0, lx = 0, lt = 0, vel = 0, raf;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        cancelAnimationFrame(raf); down = true; moved = false; sx = lx = e.clientX; sl = track.scrollLeft; lt = performance.now(); vel = 0;
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx;
        if (!moved && Math.abs(dx) > 5) { moved = true; track.classList.add('is-dragging'); }
        if (!moved) return;
        track.scrollLeft = sl - dx;
        var now = performance.now(), dt = Math.max(1, now - lt);
        vel = vel * 0.6 + ((lx - e.clientX) / dt) * 0.4; lx = e.clientX; lt = now;
      });
      function end() {
        if (!down) return; down = false; track.classList.remove('is-dragging');
        if (!moved) return;
        var v = vel * 16;
        (function glide() { if (Math.abs(v) < 0.4) return; track.scrollLeft += v; v *= 0.94; raf = requestAnimationFrame(glide); })();
      }
      window.addEventListener('pointerup', end); window.addEventListener('pointercancel', end);
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      /* pendulum sway */
      var k = { off: 0, low: 0.5, medium: 1, high: 1.7 }[root.dataset.motion]; if (k === undefined) k = 1;
      if (!k || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var ptr = null, on = false, last = performance.now(), lastSL = track.scrollLeft, sv = 0;
      root.addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse') ptr = e.clientX; });
      root.addEventListener('pointerleave', function () { ptr = null; });
      function frame(now) {
        if (!on) return;
        var dt = Math.min(32, now - last) / 16.67; last = now;
        sv += (((track.scrollLeft - lastSL) / 16.67) - sv) * 0.18; lastSL = track.scrollLeft;
        items.forEach(function (g) {
          var r = g.li.getBoundingClientRect(); if (r.right < -200 || r.left > innerWidth + 200) return;
          var t = -Math.max(-16, Math.min(16, sv * 6)) * k;
          if (ptr !== null) { var dx = r.left + r.width / 2 - ptr, n = dx / (r.width * 0.95); t += -Math.sign(dx) * Math.exp(-n * n) * 5.5 * k; }
          t += Math.sin(now / 1800 + g.ph) * 0.45 * k;
          g.v += ((t - g.a) * 0.075 - g.v * 0.11) * dt; g.a += g.v * dt;
          g.el.style.transform = Math.abs(g.a) < 0.005 ? '' : 'rotate(' + g.a.toFixed(3) + 'deg)';
        });
        requestAnimationFrame(frame);
      }
      new IntersectionObserver(function (es) {
        if (es[0].isIntersecting && !on) { on = true; last = performance.now(); requestAnimationFrame(frame); }
        else if (!es[0].isIntersecting) { on = false; }
      }, { rootMargin: '100px' }).observe(root);
    }
    function all(scope) { (scope || document).querySelectorAll('[data-gr]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); }); else all();
    document.addEventListener('shopify:section:load', function (e) { all(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
